// SparkPlug has already approved this exact name. Use its assignment ahead of
// browser guesses and retain it without a second review or a time-based lease.
export function reviewedCanonicalProduct(product) {
  if (product?.canonicalMatch?.method !== 'reviewed_sparkplug_alias') return undefined;
  return product.canonicalMatch.status === 'matched' ? product.canonicalProduct || null : null;
}
export function resolveCanonicalProduct(product, fallback) {
  const approved = reviewedCanonicalProduct(product);
  return approved === undefined ? fallback() : approved;
}
